import { useMemo } from 'react';
import { useAppContext } from '../../../../context/AppContext';

/**
 * Hook personnalisé pour gérer les couleurs des catégories dans UnifiedMarkerModal
 */
export const useCategoryColors = (categoryId: string | null) => {
  const { state } = useAppContext();

  // Fonction pour obtenir la couleur de la catégorie avec une opacité réduite
  const getCategoryBackgroundColor = useMemo(() => {
    if (!categoryId) return undefined;
    
    const category = state.categories.find(cat => cat.id === categoryId);
    if (!category) return undefined;
    
    // Convertir la couleur hexadécimale en rgba avec une opacité de 0.15
    const hexToRgba = (hex: string, opacity: number) => {
      // Supprimer le # si présent
      hex = hex.replace('#', '');
      
      // Convertir en RGB
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      
      // Retourner en format rgba
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    };
    
    return hexToRgba(category.color, 0.6);
  }, [categoryId, state.categories]);
  
  // Récupérer la couleur pure de la catégorie pour la bordure
  const getCategoryBorderColor = useMemo(() => {
    if (!categoryId) return '#4CAF50'; // Couleur par défaut
    
    const category = state.categories.find(cat => cat.id === categoryId);
    return category ? category.color : '#4CAF50';
  }, [categoryId, state.categories]);

  return {
    getCategoryBackgroundColor,
    getCategoryBorderColor
  };
};

